module.exports = __webpack_public_path__ + "media/cloth_3.1a185a70.webm";